// extracted by mini-css-extract-plugin
export default {"wrap_modal":"Frame_wrap_modal__OH-bz","modal_content":"Frame_modal_content__Worgr","header":"Frame_header__4buHW","main":"Frame_main__D84JW"};